import { useLocation, useNavigate } from "react-router-dom";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import { addEditServiceRequest } from "../../../commons/ServiceRequest";
import IssueRepairForm from "../../../components/RepairWork/IssueRepairForm";
import SeqRepairJobsService from "../../../services/seqrepairjob.service";

export default function CreateRepairWorkOrders() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  let SearchValue = [
    { name: "seq_repair_date", label: "วันที่ออกใบสั่งงาน", type: "date" },
    {
      name: "id",
      labelName: "seq_repair_no",
      label: "เลขที่ใบสั่งแจ้งซ่อม",
      noneAsync: true,
      filterBy: ["seq_repair_no"]
    }
  ];

  return (
    <IssueRepairForm
      onSubmitCallback={(data) => {
        addEditServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: SeqRepairJobsService.createSeqRepairJob(data),
          callback: (res) =>
            (SearchValue = SearchValue.map((item) =>
              item.name === "seq_repair_date"
                ? { ...item, value: data.seq_repair_date }
                : { ...item, value: `${res.generatedMaps?.[0]?.id}` }
            )),
          navigated: (navi) => {
            if (navi) {
              navigate(pathname, { state: { name: "search", SearchValue } });
              navigate(0);
            }
          }
        });
      }}
    />
  );
}
